import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { ajax } from './utils/http.js'

// 创建应用实例
const app = createApp(App)

// 全局挂载ajax函数
app.config.globalProperties.$ajax = ajax
// 或者挂载到window对象（使现有代码无需修改）
window.ajax = ajax

// 使用路由
app.use(router)

// 挂载到 #app 元素
app.mount('#app')
